/* Library */
import React, { Component } from 'react';

class OffersEvent extends Component {
  render() {
    const data = this.props.offerTargeter && this.props.offerTargeter.data ? this.props.offerTargeter.data : null;
    return (
      <div id="offerEvents" dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
}

export default OffersEvent;

